import React from 'react'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import InputTags from '../../views/widgets/InputTags'
import GeneralInfoFormLocationContainer from './GeneralInfoFormLocationContainer'
import GeneralInfoActionPanel from './GaneralInfoActionPanel'
import GeneralInfoNoteButton from './GeneralInfoNoteButton'
import InputTextTagSuggestion from './InputTextTagSuggestion'
import InputTextWithMaxLength from '../../views/widgets/InputTextWithMaxLength'
import InputTextWithSuggestion from '../../views/widgets/InputTextWithSuggestion'
import InputTextareaWithSuggestion from '../../views/widgets/InputTextareaWithSuggestion'
import InputTextarea from '../../views/widgets/InputTextarea'
import GeneralInfoFormContributorContainer from './GeneralInfoFormContributorContainer'
import { handleFullSocialLink } from './GeneralInfoFormContainer'

const GeneralInfoForm = ({
  isEditing,
  initialValues,
  onValidate,
  onSubmit,
  onDelete,
  language = 'th',
}) => {
  const { t } = useTranslation()

  return (
    <Formik
      enableReinitialize={true}
      validateOnChange={true}
      isInitialValid={false}
      initialValues={initialValues}
      validate={onValidate}
      onSubmit={onSubmit}
    >
      {({
        values,
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        setValues,
        setFieldValue,
      }) => (
        <React.Fragment>
          <GeneralInfoActionPanel
            onSubmit={handleSubmit}
            onDelete={onDelete}
            isEditing={isEditing}
          />
          <GeneralInfoNoteButton notes={values.notes} />
          <hr />
          <h2 className="title is-4">{t('info.label')}</h2>
          <Field label={`${t('info.title.label')}[${language}]`}>
            <InputText
              name={`title.${language}`}
              placeholder={t('info.title.placeholder')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.title[language]}
              error={errors.title && errors.title[language]}
            />
          </Field>
          <Field label={t('info.tags.label')}>
            <InputText
              name={`tags`}
              placeholder={t('info.tags.placeholder')}
              onChange={e => {
                setFieldValue(
                  'tags',
                  _.chain(e.target.value)
                    .trim()
                    .split(',')
                    .value(),
                )
              }}
              value={values.tags}
            />
            <InputTags
              name={`tags`}
              placeholder={t('info.tags.placeholder')}
              onChange={value => {
                setFieldValue('tags', value)
              }}
              values={values.tags}
              error={errors.tags && errors.tags[language]}
              renderInputText={InputTextTagSuggestion}
              textAction={t('actions.add.label')}
            />
          </Field>
          <Field label={`${t('info.shortDescription.label')}[${language}]`}>
            <InputTextWithMaxLength
              maxLength={40}
              name={`shortDescription.${language}`}
              placeholder={t('info.shortDescription.placeholder')}
              onChange={handleChange}
              value={values.shortDescription[language]}
            />
          </Field>
          <Field label={`${t('info.description.label')}[${language}]`}>
            <InputTextareaWithSuggestion
              suggestMinLength={200}
              name={`description.${language}`}
              placeholder={t('info.description.placeholder')}
              onChange={handleChange}
              value={values.description[language]}
            />
          </Field>
          <Field label={`${t('info.highlightSentence.label')}[${language}]`}>
            <InputTextWithSuggestion
              suggestMinLength={60}
              name={`highlightSentence.${language}`}
              placeholder={t('info.highlightSentence.placeholder')}
              onChange={handleChange}
              value={values.highlightSentence[language]}
            />
          </Field>

          <Field label={`${t('info.editorNotes.label')}[${language}]`}>
            <InputText
              name={`editorNotes.${language}`}
              placeholder={t('info.editorNotes.placeholder')}
              onChange={handleChange}
              value={values.editorNotes[language]}
            />
          </Field>

          <Field label={`${t('info.openingHours.label')}[${language}]`}>
            <InputTextarea
              name={`openingHours.${language}`}
              placeholder={t('info.openingHours.placeholder')}
              onChange={handleChange}
              value={values.openingHours[language]}
            />
          </Field>
          <Field label={`ใช้ใน website`}>
            <div class="control">
              <label class="radio">
                <input
                  type="radio"
                  name="isUseInWeb"
                  checked={values.isUseInWeb}
                  onChange={e => {
                    setFieldValue(`isUseInWeb`, true)
                  }}
                />
                Yes
              </label>
              <label class="radio">
                <input
                  type="radio"
                  name="isUseInWeb"
                  checked={!values.isUseInWeb}
                  value={values.isUseInWeb}
                  onChange={e => {
                    setFieldValue(`isUseInWeb`, false)
                  }}
                />
                No
              </label>
            </div>
          </Field>

          <hr />
          <h2 className="title is-4">{t('contacts.label')}</h2>

          <Field label={t('contacts.email.label')}>
            <InputText
              name={`contacts.email`}
              type="email"
              placeholder={t('contacts.email.placeholder')}
              onChange={handleChange}
              value={values.contacts.email}
              error={errors.email && errors.email[language]}
            />
          </Field>
          <Field label={t('contacts.phone.label')}>
            <InputText
              name={`contacts.phone`}
              placeholder={t('contacts.phone.placeholder')}
              onChange={handleChange}
              value={values.contacts.phone}
            />
            <InputTags
              name={`contacts.phone`}
              placeholder={t('contacts.phone.placeholder')}
              onChange={value => {
                setFieldValue('contacts.phone', value.join(','))
              }}
              values={values.contacts.phone.split(',')}
              error={errors.tags && errors.tags[language]}
            />
          </Field>
          <Field label={t('contacts.fanpage.label')}>
            <div className="field has-addons">
              <div className="control">
                <a className="button is-static">https://www.facebook.com/</a>
              </div>
              <InputText
                name={`contacts.fanpage`}
                placeholder={t('contacts.fanpage.placeholder')}
                onChange={e => {
                  const value = handleFullSocialLink(e.target.value)
                  setFieldValue('contacts.fanpage', value)
                }}
                value={values.contacts.fanpage}
              />
            </div>
          </Field>
          <Field label={t('contacts.fbPageId.label')}>
            <InputText
              name={`contacts.fbPageId`}
              placeholder={t('contacts.fbPageId.placeholder')}
              onChange={handleChange}
              value={values.contacts.fbPageId}
            />
          </Field>
          <Field label={t('contacts.instragramId.label')}>
            <div className="field has-addons">
              <div className="control">
                <a className="button is-static">https://www.instagram.com/</a>
              </div>
              <InputText
                name={`contacts.instragramId`}
                placeholder={t('contacts.instragramId.placeholder')}
                onChange={e => {
                  const value = handleFullSocialLink(e.target.value)
                  setFieldValue('contacts.instragramId', value)
                }}
                value={values.contacts.instragramId}
              />
            </div>
          </Field>
          <Field label={t('contacts.lineId.label')}>
            <InputText
              name={`contacts.lineId`}
              placeholder={t('contacts.lineId.placeholder')}
              onChange={handleChange}
              value={values.contacts.lineId}
            />
          </Field>
          <Field label={t('contacts.webpage.label')}>
            <InputText
              name={`contacts.webpage`}
              placeholder={t('contacts.webpage.placeholder')}
              onChange={handleChange}
              value={values.contacts.webpage}
            />
          </Field>
          <Field label={t('contacts.others.label')}>
            <InputText
              name={`contacts.others.${language}`}
              placeholder={t('contacts.others.placeholder')}
              onChange={handleChange}
              value={values.contacts.others[language]}
            />
          </Field>

          <hr />
          <h2 className="title is-4">{t('place.label')}</h2>

          <GeneralInfoFormLocationContainer
            key={values._id}
            language={language}
            locationInfo={values.location}
            onLatLngChange={(lat, lng) => {
              setValues({
                ...values,
                location: {
                  ...values.location,
                  latitude: lat,
                  longitude: lng,
                },
              })
            }}
            onLocationChange={({ name, value }) => {
              setFieldValue(name, value)
            }}
          />

          <hr />
          <h2 className="title is-4">{t('contributor.label')}</h2>
          <GeneralInfoFormContributorContainer
            contributors={values.contributors}
            onContributorChange={contributors => {
              setFieldValue('contributors', contributors)
            }}
          />
          <hr />
          <GeneralInfoActionPanel
            onSubmit={handleSubmit}
            onDelete={onDelete}
            isEditing={isEditing}
          />
        </React.Fragment>
      )}
    </Formik>
  )
}

export default GeneralInfoForm



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoForm.js